import SettingsComponent from "../../components/shared/SettingsComponent"
import { HellocianSidebarLayout } from "../../components/HellocianSidebar"

const HellocianSettings = () => {
    return (
           <HellocianSidebarLayout currentPath="/settings">
        <SettingsComponent />
           </HellocianSidebarLayout>
    )
}

export default HellocianSettings
